 
export enum Toggle {
   'MY_INVOICES' = 'my-invoices',
   'CLOSED_INVOICES' = 'my-invoices-closed',
   'FILTERS' = 'my-invoices-filters',
   'ONLINE_PAYMENT' = 'my-invoices-online-payment',
   'DEDUCT_CREDIT_NOTED' = 'my-invoices-deduct-credit-notes'
}
